<div class="p-4 lg:p-10 flex-1 flex flex-col">
  <div class="flex flex-col gap-6 py-6">
    <h2 class="font-canelablack-primary text-4xl md:text-5xl">
      <T
        str="Account created!"
        key="customerPortal.kc.register-finish.title"
        tags="kc-forms, 3.1"
      >
      </T>
    </h2>
    <mat-card
      class="flex flex-row gap-6 items-center py-7 px-10 mb-5 border border-at-ef-revolution-supergrey-500 rounded-lg mat-elevation-z0"
    >
      <mat-icon
        class="card-flex-rounded-icon"
        svgIcon="check_circle_outline"
      ></mat-icon>
      <!-- prettier-ignore -->
      <p
        class="font-efSans-primary"
        [innerHTML]="getTranslation()"
      ></p>
    </mat-card>
    <button
      data-cy="registration-finish-submit-button"
      mat-button
      mat-flat-button
      color="secondary"
      class="revolution w-full lg:w-1/2 button-spinner"
      (click)="submit()"
      [disabled]="submitting"
    >
      <customer-portal-ef-spinner
        [color]="'mat-ef-revolution-grey-two-500'"
        [opacity]="0.7"
        [diameter]="16"
        *ngIf="submitting"
      >
      </customer-portal-ef-spinner>
      <T
        str="Continue to the Emil Frey customer portal"
        key="customerPortal.kc.register-finish.button-kundenportal"
        tags="kc-forms, 3.1"
      >
      </T>
    </button>
    <form
      #registerFinishForm
      [action]="viewData.registrationAction"
      method="POST"
    >
      <input type="hidden" name="step" value="finish" />
    </form>
  </div>
</div>
